import React, { Component } from 'react';

import { connect } from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as AdminActions from '../../actions/adminActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as CompanyInfoActions from '../../actions/companyInfoActions';

class DeleteRoleModal extends Component {

    deleteRole = async () => {
        const { companyInfo, currentUser, deleteAuthorizationRole, currentRole } = this.props;

        if (currentUser.role.id === currentRole.id) {
            this.props.enqueueSnackbar('Cannot delete your currently assigned role.', 'error');
            return;
        }

        let isDeleted = await deleteAuthorizationRole(currentRole.id, companyInfo.companyId);

        if (isDeleted) {
            currentRole.id = currentUser.role.id;
            currentRole.name = currentUser.role.name;
            currentRole.description = currentUser.role.description;

            this.props.close(currentRole);
        }
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.close();
    }

    render() {
        const {open, title, message, errors} = this.props;

        return (
            <EsmsDialog
                errors={errors}
                confirmText="Confirm"
                onCancel={this.handleClose}
                onClose={this.handleClose}
                onConfirm={this.deleteRole}
                onRendered={this.props.clearErrors}
                open={open}
                title={title}
            >
                {message}
            </EsmsDialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        currentUser: state.currentUser
    };
};

const mapDispatchToProps = {
    ...AdminActions,
    ...ApplicationMessageActions,
    ...CompanyInfoActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteRoleModal);
